<template>
  <validation-observer ref="observer">
    <v-form ref="form" @submit.prevent="handleSubmit">
      <v-row :class="justifyEnd ? 'justify-end' : ''">
        <v-col class="py-0" cols="12" md="3">
          <validation-provider
            v-slot="{ errors }"
            name="assuranceLevelId"
            :rules="rules.assuranceLevelId"
          >
            <v-select
              v-model="formData.assuranceLevelId"
              :error-messages="errors"
              :items="assuranceLevels"
              :disabled="disabledAssuranceLevel"
              item-text="name"
              item-value="id"
              label="ระดับ"
              outlined
              dense
              @change="onAssuranceLevelChange"
            ></v-select>
          </validation-provider>
        </v-col>
        <v-col class="py-0" cols="12" md="3">
          <validation-provider
            v-slot="{ errors }"
            name="yearId"
            :rules="rules.yearId"
          >
            <v-select
              v-model="formData.yearId"
              :error-messages="errors"
              :items="years"
              item-text="name"
              item-value="id"
              label="ปี"
              outlined
              dense
              @change="onYearChange"
            ></v-select>
          </validation-provider>
        </v-col>
        <v-col v-if="showFaculty" class="py-0" cols="12" md="3">
          <validation-provider
            v-slot="{ errors }"
            name="facultyId"
            :rules="rules.facultyId"
          >
            <v-select
              v-model="formData.facultyId"
              :error-messages="errors"
              :items="faculties"
              item-text="name"
              item-value="id"
              label="คณะ"
              outlined
              dense
              @change="onFacultyChange"
            ></v-select>
          </validation-provider>
        </v-col>
        <v-col v-if="showMajor" class="py-0" cols="12" md="3">
          <validation-provider
            v-slot="{ errors }"
            name="majorId"
            :rules="rules.majorId"
          >
            <v-select
              v-model="formData.majorId"
              :error-messages="errors"
              :items="majorOptions"
              :disabled="disabledMajor"
              item-text="name"
              item-value="id"
              label="สาขา"
              outlined
              dense
              @change="onMajorChange"
            ></v-select>
          </validation-provider>
        </v-col>

        <v-col
          class="py-0"
          cols="12"
          :md="`${formData.assuranceLevelId === 3 ? 12 : 1}`"
        >
          <div
            :class="`${formData.assuranceLevelId === 3 ? 'text-right' : ''}`"
          >
            <v-btn :loading="submitLoading" color="primary" type="submit">
              ตกลง
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </validation-observer>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"

export default {
  name: "FormSelectAssuranceInput",
  props: {
    justifyEnd: {
      type: Boolean,
      default: false,
    },
    assuranceLevel: {
      type: Number | String,
      default: "",
    },
    initForm: {
      type: Object,
      default: () => ({}),
    },
    disabledAssuranceLevel: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      formData: {
        assuranceLevelId: "",
        yearId: "",
        facultyId: "",
        majorId: "",
      },
      rules: {
        assuranceLevelId: "required",
        yearId: "required",
        facultyId: "required",
        majorId: "required",
      },

      facultyOptions: [],
      
      majorOptions: [],
      disabledMajor: true,

      submitLoading: false,
      showFaculty: false,
      showMajor: false,
    }
  },
  computed: {
    ...mapGetters(["assuranceLevels", "years", "faculties", "majors", "currentUser", "hasAnyRole"]),
  },
  watch: {
    assuranceLevel(newVal) {
      if (this.assuranceLevel) {
        this.formData.assuranceLevelId = newVal
        this.onAssuranceLevelChange(newVal)
      }
    },
    initForm: {
      handler() {
        this.setForm()
      },
      deep: true,
    },
  },
  mounted() {
    if (this.assuranceLevel) {
      this.formData.assuranceLevelId = this.assuranceLevel
      this.onAssuranceLevelChange(this.assuranceLevel)
    }

    this.initAffiliation()
    this.setForm()
  },
  methods: {
    setForm() {
      if (!_.isEmpty(this.initForm)) {
        const { assuranceLevelId, facultyId, majorId } = this.initForm

        this.formData.assuranceLevelId = assuranceLevelId
        this.onAssuranceLevelChange(assuranceLevelId)

        this.formData.facultyId = facultyId
        this.onFacultyChange(facultyId)

        this.formData.majorId = majorId
        this.onMajorChange(majorId)
      }
    },
    onAssuranceLevelChange(value) {
      this.clearContent()

      this.formData.facultyId = ""
      this.formData.majorId = ""

      if (value === 2) {
        this.rules.facultyId = "required"
        this.rules.majorId = ""
        this.showFaculty = true
        this.showMajor = false
      } else if (value === 3) {
        this.rules.facultyId = "required"
        this.rules.majorId = "required"
        this.showFaculty = true
        this.showMajor = true
      } else {
        this.rules.facultyId = ""
        this.rules.majorId = ""
        this.showFaculty = false
        this.showMajor = false
      }
    },
    onYearChange(value) {
      this.clearContent()
      this.formData.yearId = value
    },
    onFacultyChange(value) {
      this.clearContent()

      this.majorOptions = this.majors.filter(
        (major) => major.faculty_id === value
      )

      this.disabledMajor = false

      this.formData.facultyId = value
      this.formData.majorId = ""
    },
    onMajorChange(value) {
      this.clearContent()
      this.formData.majorId = value
    },
    initAffiliation() {
      if(this.hasAnyRole(["faculty_manager", "course_manager"])) {
        this.facultyOptions = this.facultyOptions.filter(({ id }) => id === this.currentUser.faculty.id)
      }

      if(this.hasAnyRole(["course_manager"])) {
        this.majorOptions = this.majorOptions.filter(({ id }) => id === this.currentUser.major.id)
      }
    },
    clearContent() {
      this.$emit("clearContent")
    },
    async handleSubmit() {
      const validated = await this.$refs.observer.validate()

      if (validated) {
        this.$emit("onSubmit", this.formData)
      }
    },
  },
}
</script>